import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatofrmHero = styled.section`
	color: ${CSSVars.white};
	text-align: center;
	overflow: hidden;
	background: ${CSSVars.gray700};
	padding: 10px 20px 150px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 20px 40px 200px;
	}

	.hero-wrapper {
		h1 {
			position: relative;
			z-index: 10;
			font-size: ${CSSVars.fontSize2XL};
			font-weight: 600;
			max-width: 1200px;
			text-align: left;
			margin: 0 auto 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 0 auto 30px;
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize4XL};
			}

			span {
				text-transform: capitalize;
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			font-weight: 300;
			max-width: 980px;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}
	}
`;
